import { useCollateralStrings } from "module/vault/hook/useCollateralStrings"

import { Box, Flex, HStack, Progress, Text, VStack } from "@chakra-ui/react"
import { Card } from "component/Card"
import { MarketListIcon } from "component/MarketListIcon"
import ReactMarkdown from "react-markdown"

const content = `
# Collateral Deposit Cap

The current status of collateral deposit on Perpetual Protocol. [Learn more  ↗](https://support.perp.com/hc/en-us/articles/5257432076569-Multi-collateral#heading-2)
`
// Users will see this card unless connected
// TODO: Show cap card no matter connected or not

export function CollateralCap() {
    const { collateralStrList } = useCollateralStrings()

    return (
        <Card p={0} display="flex" flexDirection={"column"}>
            <Flex
                bgGradient="linear(to-br, perpetual.900, orange.900)"
                h="full"
                justify={"center"}
                flexDirection={"column"}
                flexGrow={1}
                py={"40px"}
                px={{ base: 6, lg: 8 }}
            >
                {collateralStrList?.map(({ symbol, depositCap, depositAmount, depositPercentage }) => {
                    return !depositCap ? null : (
                        <Box w="full" py={"20px"} key={symbol}>
                            <HStack w="full" justify={"space-between"}>
                                <HStack spacing={2}>
                                    <Box boxSize={"24px"}>
                                        <MarketListIcon coin={symbol} />
                                    </Box>
                                    <Text>{symbol}</Text>
                                </HStack>
                                <Text align="right">
                                    {depositAmount}
                                    <Text as="span" opacity={0.5}>
                                        {" "}
                                        / {depositCap.toString()}
                                    </Text>
                                </Text>
                            </HStack>
                            <Box h={4} pt={3}>
                                <Progress borderRadius={"full"} isAnimated h={1} value={Number(depositPercentage)} />
                            </Box>
                        </Box>
                    )
                })}
            </Flex>
            <VStack flexGrow={0} align="stretch" spacing={6} p={{ base: 6, lg: 8 }} pb={{ base: 5, lg: 7 }}>
                <Box>
                    <ReactMarkdown
                        className="markdown"
                        components={{
                            // Use h2s instead of h1s
                            a: props => {
                                return (
                                    <a href={props.href} target="_blank" rel="noreferrer">
                                        {props.children}
                                    </a>
                                ) // All links
                            },
                        }}
                        children={content}
                    />
                </Box>
            </VStack>
        </Card>
    )
}
